<template>
  <b-button
    class="mini-button text-nowrap p-1"
    size="sm"
    :variant="variant"
    :to="to"
    v-on="$listeners">
    <slot />
  </b-button>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: undefined
    },
    variant: {
      type: String,
      default: 'primary'
    }
  },
}
</script>

<style lang="scss">
.mini-button {
  font-size: 12px !important;
  box-shadow: 1px 2px 6px $grey05;
  text-decoration: none;
}
</style>